export enum ESortByType {
  Name = 'name',
  Value = 'value',
  SignDate = 'signDate',
  ContractPeriod = 'contractPeriod',
  Owner = 'owner',
}
